// Add-on parts of the statistics ("Zusätze"): income bars of the breakdown chart and their tooltip split.
// The backend groups add-on lines by add-on (current catalog name) or, for lines whose catalog entry is gone, by
// the line's name snapshot — old events show the rental as "Leihausrüstung" and articles under their names.
// colorKey = live catalog color of the add-on ('neutral' for rows grouped by name, and for old responses without it).
import { addOnColorKey, hasAddOnColor } from '../../util/addOns';
import { colorVar } from '../../util/participantGroups';
import { participantGroupColor } from './chartColors';

const fmtEuro = (cents) => ((cents ?? 0) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// AddOnIncomeStat[] (event: { name, cents, signupCents, onSiteCents, colorKey }) or AddOnYearStat[] (year:
// { name, cents, colorKey }) → bar rows { name, Betrag (€), signupCents?, onSiteCents?, colorKey } in the backend
// order (process rows, then by name).
export function addOnIncomeBars(addOns) {
  return (Array.isArray(addOns) ? addOns : [])
    .filter(a => a && a.name)
    .map(a => ({
      name: a.name,
      Betrag: (a.cents ?? 0) / 100,
      signupCents: a.signupCents,
      onSiteCents: a.onSiteCents,
      colorKey: addOnColorKey(a.colorKey),
    }));
}

// Chart color of an add-on row (bar, usage card) — the palette color of its own color, null for "Ohne Farbe"
// (the caller keeps its usual color then). colors = readThemeColors().
export function addOnChartColor(colors, colorKey) {
  return hasAddOnColor(colorKey) ? participantGroupColor(colors, addOnColorKey(colorKey)) : null;
}

// Icon color of an add-on's usage card (StatsCard iconColor): the palette token (follows light/dark via CSS),
// undefined for "Ohne Farbe" (default icon color).
export const addOnIconColor = (colorKey) =>
  (hasAddOnColor(colorKey) ? colorVar(addOnColorKey(colorKey)) : undefined);

// Tooltip lines of a bar (ChartTooltip `details`): split of an add-on's income into the sign-up share (part of
// the participant price) and on-site sales ("Artikel") — only when both channels contributed.
export function addOnIncomeDetails(datum) {
  const signup = datum?.signupCents ?? 0;
  const onSite = datum?.onSiteCents ?? 0;
  if (signup <= 0 || onSite <= 0) return [];
  return [
    `Bei der Anmeldung: ${fmtEuro(signup)} €`,
    `Im Event (Artikel): ${fmtEuro(onSite)} €`,
  ];
}
